<div class="panel-tabs">
    <nav>
        <ul class="nav nav-pills">
            <li [routerLinkActive]="['active']" *ngFor="let tab of tabs">
                <a [routerLink]="['./' + tab.linkText]">
                    <span>{{ tab.translationKey | translate }}</span>
                </a>
            </li>
        </ul>
    </nav>
</div>
<div class="card">
    <div class="card-body">
        <router-outlet></router-outlet>
    </div>
</div>